import React from "react";

const Original = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4444 0H1.55556C0.7 0 0 0.7 0 1.55556V12.4444C0 13.3 0.7 14 1.55556 14H12.4444C13.3 14 14 13.3 14 12.4444V1.55556C14 0.7 13.3 0 12.4444 0ZM12.4444 12.4446H1.55556V1.55566H12.4444V12.4446ZM6.38556 9.97892L8.52444 7.22559L11.2778 10.8889H2.72222L4.86111 8.14336L6.38556 9.97892Z"
        fill="#bfbfbf"
      />
    </svg>
  );
};

export default Original;
